import React, {useMemo} from "react";
import Modal from "./ui/Modal";
import Icon from "./ui/Icon";
import Avatar from "./ui/Avatar";

const PETAL_COLORS = ["#f4b6c4", "#e2849a", "#fbe4ea", "#f0c25e", "#a9cf8f"];

const Petals = () => {
    const petals = useMemo(() => Array.from({length: 26}).map((_, i) => ({
        left: Math.random() * 100,
        delay: Math.random() * 0.9,
        duration: 2 + Math.random() * 1.6,
        color: PETAL_COLORS[i % PETAL_COLORS.length],
        scale: 0.7 + Math.random() * 0.7
    })), []);
    return (
        <div className="confetti" aria-hidden="true">
            {petals.map((petal, i) => (
                <span key={i} style={{
                    left: `${petal.left}%`,
                    background: petal.color,
                    animationDelay: `${petal.delay}s`,
                    animationDuration: `${petal.duration}s`,
                    transform: `scale(${petal.scale})`
                }}/>
            ))}
        </div>
    );
};

const TITLES = {
    win: "You won!",
    loss: "You lost",
    draw: "It's a draw"
};

const ICONS = {
    win: "trophy",
    loss: "leaf",
    draw: "handshake"
};

/**
 * Result card shown when a game ends.
 * outcome: "win" | "loss" | "draw"
 */
const GameOverModal = ({
                           outcome,
                           reason,
                           opponent,
                           onClose,
                           onAnalysis,
                           onHome,
                           rematch,
                           onOfferRematch,
                           onAnswerRematch,
                           eloDelta,
                           rematchLabel = "Rematch"
                       }) => {
    return (
        <Modal onClose={onClose} size="sm" className={`result--${outcome}`} labelledBy="result-title" hideClose>
            <div className="result-hero">
                {outcome === "win" && <Petals/>}
                <button className="icon-btn" onClick={onClose} aria-label="Close and look at the board"
                        style={{position: "absolute", top: 10, right: 10}}>
                    <Icon name="close"/>
                </button>
                <div className="result-hero__icon">
                    <Icon name={ICONS[outcome]} strokeWidth={1.7}/>
                </div>
                <h2 id="result-title">{TITLES[outcome]}</h2>
                {reason && <p>{reason}</p>}
                {eloDelta !== undefined && eloDelta !== null && (
                    <div style={{marginTop: "0.6rem"}}>
                        <span className={`chip ${eloDelta > 0 ? "chip--leaf" : eloDelta < 0 ? "chip--blossom" : ""}`}>
                            Rating {eloDelta > 0 ? `+${eloDelta}` : eloDelta}
                        </span>
                    </div>
                )}
            </div>
            <div className="modal-body stack">
                {opponent && (
                    <div className="row small muted" style={{justifyContent: "center"}}>
                        <span>vs</span>
                        <Avatar name={opponent.username} size={22} guest={!opponent.isActualUser}/>
                        <strong style={{color: "var(--ink)"}}>{opponent.username}</strong>
                    </div>
                )}

                {rematch?.incomingId ? (
                    <div className="inline-offer">
                        <span className="pulse-dot"/>
                        <span className="inline-offer__text">{opponent?.username || "Your opponent"} wants a rematch</span>
                        <div className="row">
                            <button className="btn btn-primary btn-sm" onClick={() => onAnswerRematch(true)}>Accept</button>
                            <button className="btn btn-sm" onClick={() => onAnswerRematch(false)}>Decline</button>
                        </div>
                    </div>
                ) : (
                    <button className="btn btn-primary btn-lg btn-block" onClick={onOfferRematch}
                            disabled={rematch?.status === "sent" || rematch?.status === "declined"}>
                        {rematch?.status === "sent" ? <><span className="spinner spinner--sm spinner--light"/> Waiting for opponent…</> :
                            rematch?.status === "declined" ? "Rematch declined" :
                                <><Icon name="refresh"/> {rematchLabel}</>}
                    </button>
                )}
                {rematch?.error && <div className="form-error">{rematch.error}</div>}

                <div className="action-row">
                    <button className="btn" onClick={onAnalysis}><Icon name="sparkles"/> Review game</button>
                    <button className="btn" onClick={onHome}><Icon name="board"/> New game</button>
                </div>
            </div>
        </Modal>
    );
};

export default GameOverModal;
